function cleanString(value) {
  return typeof value === "string" ? value.trim() : "";
}

function isSpanish(locale) {
  return cleanString(locale).toLowerCase().startsWith("es");
}

export function getDecorativeCoverAlt(value) {
  return cleanString(value);
}

export function getRecordCoverImage(recordValue, metadataValue) {
  return cleanString(recordValue) || cleanString(metadataValue) || undefined;
}

export function getArticleCoverAlt(value, locale) {
  return (
    cleanString(value) ||
    (isSpanish(locale) ? "Imagen de portada del articulo" : "Article cover image")
  );
}

export function getGalleryImageAlt(value, locale, index) {
  const explicit = cleanString(value);
  if (explicit) return explicit;
  const position = Number.isInteger(index) && index >= 0 ? index + 1 : 1;
  return isSpanish(locale)
    ? `Imagen complementaria ${position} del articulo`
    : `Supporting article image ${position}`;
}

function imageList(value) {
  if (Array.isArray(value)) return value.map(cleanString).filter(Boolean);
  const text = cleanString(value);
  return text ? text.split(/\r?\n/).map(cleanString).filter(Boolean) : [];
}

export function isConcreteImageAlt(value) {
  const normalized = cleanString(value).toLowerCase().replace(/\s+/g, " ");
  const generic = new Set([
    "blog cover",
    "cover image",
    "imagen de portada",
    "imagen del blog",
    "article illustration",
    "visual editorial",
  ]);
  return (
    normalized.length >= 16 &&
    normalized.split(/\s+/).filter(Boolean).length >= 3 &&
    !generic.has(normalized) &&
    !/^https?:\/\//.test(normalized)
  );
}

export function getGalleryAltIssues(imagesValue, altsValue) {
  const images = imageList(imagesValue);
  const alts = imageList(altsValue);
  if (images.length === 0) return [];
  const issues = [];
  if (alts.length !== images.length) {
    issues.push(`La galeria tiene ${images.length} imagen(es) y ${alts.length} texto(s) alternativo(s).`);
  }
  images.forEach((_image, index) => {
    if (!isConcreteImageAlt(alts[index])) {
      issues.push(`La imagen de galeria ${index + 1} necesita un texto alternativo concreto.`);
    }
  });
  return issues;
}

export function getOpenGraphImages(url, alt) {
  const cleanUrl = cleanString(url);
  if (!cleanUrl) return undefined;
  const cleanAlt = cleanString(alt);
  return [{ url: cleanUrl, ...(cleanAlt ? { alt: cleanAlt } : {}) }];
}
